import { useQuery } from '@tanstack/react-query'

import { get } from '@/services/awsAmplify'

import { QueryKeys } from '@/enums'

type GetDepositDataResult = {
  walletAddress: string
  minDepositAmount: string
}

const getDepositData = async (): Promise<GetDepositDataResult> => {
  return get({ path: '/fireblocks/wallet-address' })
}

export const useDeposit = () =>
  useQuery({
    queryKey: [QueryKeys.DepositData],
    queryFn: getDepositData,
  })
